import api from "@services/apiList";
import instance from "@services/services";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { InsuranceReceiverType } from "../types";

const { patientEncounterApi, reportsApi } = api;

export type PatientClaimListPayload = {
  fromDate: string;
  toDate: string;
  insuranceId: number;
};

export const getPatientClaimInsuranceList = async (): Promise<
  ResponseType<InsuranceReceiverType[]>
> => {
  const result = await instance.post(patientEncounterApi.getInsByTpe, {
    searchText: null,
    typeId: 1,
    clinicId: 1,
  });
  return result.data;
};

export const getClaimTemplateQatar = async (
  payload: PatientClaimListPayload,
): Promise<ResponseType<string | { file?: string }>> => {
  const result = await instance.post(reportsApi.claimTemplateQatar, payload);
  return result.data;
};
